import { useEffect, useState } from 'react';

import { FormikProps, useFormikContext } from 'formik';
import styles from './ObjectContactsForm.module.scss';
import IntlTelInput from '../IntlTelInput';
import Input from '../Input';
import { InputModeType, InputType } from '../../utils/@globalTypes';
import {
  latitudeMask,
  longitudeMask,
  REQUIRED_FIELD_ERROR,
  TELEPHONE_ERROR,
} from '../../utils/constants';
import { ObjectContactsFormType } from '../../redux/types/mainObjectTypes';

type ContactsProps = {
  formik: FormikProps<ObjectContactsFormType>;
};

const ObjectContactsForm = ({ formik }: ContactsProps) => {
  const {
    handleChange,
    values,
    errors,
    initialValues,
    validateField,
    setFieldTouched,
    touched,
    setFieldError,
    dirty,
  } = formik;
  const { setFieldValue } = useFormikContext<ObjectContactsFormType>();
  const [isTelephoneValid, setIsValid] = useState(false);

  // console.log(errors)  
  // console.log(isTelephoneValid)  
  
  useEffect(() => {
    if (dirty) {
      isTelephoneValid
        ? values.phone.phone_number
          ? setFieldError('phone.phone_number', TELEPHONE_ERROR)
          : setFieldError('phone.phone_number', REQUIRED_FIELD_ERROR)
        : setFieldError('phone', undefined)
        
    }
  }, [values.phone, isTelephoneValid, touched.phone]);

  useEffect(() => {
    if (touched.email && values.email) {
      validateField('email');
    }
  }, [touched, values]);

  useEffect(() => {
    if (!values.email && errors.email) {
      setFieldError('email', '');
    }
  }, [values, errors]);

  useEffect(() => {
    if (touched.lon) {
      validateField('lon');
    }
    if (touched.lat) {
      validateField('lat');
    }
  }, [touched, values]);

  return (
    <div>
      <div className={styles.form}>
        <IntlTelInput
          id="phone"
          title="Мобильный телефон*"
          value={values.phone}
          placeholder="Введите номер"
          onChange={(val) => {
            setFieldValue('phone', val);
          }}
          errText={errors.phone?.phone_number}
          setError={() => {}}
          onBlur={() => setFieldTouched('phone')}
          setIsValidate={setIsValid}
          preloadedData={initialValues.phone} // первоначальная загрузка номера телефона в компонент
        />
        <Input
          id="email"
          value={values.email}
          title="Электронная почта"
          name="email"
          placeholder="Введите электронную почту"
          containerClassName={styles.inputСontainer}
          className={styles.booking}
          type={InputType.EMAIL}
          inputMode={InputModeType.EMAIL}
          errText={errors.email}
          onChange={handleChange('email')}
          onBlur={() => setFieldTouched('email')}
          banSymbols={/\s/g}
          autoComplete="email"
        />
      </div>
      <h3 className={styles.title}>Координаты GPS</h3>
      <div className={styles.form}>
        <Input
          id="lat"
          value={values.lat}
          title="Широта*"
          name="lat"
          placeholder="00.00000"
          mask={latitudeMask}
          containerClassName={styles.inputСontainer}
          className={styles.booking}
          type={InputType.MASK}
          errText={errors.lat}
          onChange={handleChange('lat')}
          onBlur={() => setFieldTouched('lat')}
          // requirementsText={TELEGRAM_REQ}
        />
        <Input
          id="lon*"
          value={values.lon || ''}
          title="Долгота*"
          name="lon"
          placeholder="00.00000"
          mask={longitudeMask}
          containerClassName={styles.inputСontainer}
          className={styles.booking}
          type={InputType.MASK}
          errText={errors.lon}
          onChange={handleChange('lon')}
          onBlur={() => setFieldTouched('lon')}

          // requirementsText={TELEGRAM_REQ}
        />
      </div>
    </div>
  );
};

export default ObjectContactsForm;
